import { select } from "redux-saga/effects";

import { history } from "state/history";
import { getParentalConsentItemByID } from "state/school_money/selectors";

export default function* goToParentalConsentItemSaga(action) {
  
  const { studentID } = yield select(getParentalConsentItemByID, action.payload.itemID);
  
  // TODO: highlighting/scrollTo
  history.push(`/school_money/parental_consent/${studentID}/`);
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/goToParentalConsentItemSaga.js